/**
 * Hook que rastreia pageviews automaticamente em cada mudança de rota.
 * Gera um sessionId persistente no sessionStorage para contar visitantes únicos.
 */
import { useEffect, useRef } from "react";
import { useLocation } from "wouter";
import { trpc } from "@/lib/trpc";
import { getSessionId } from "@/lib/conversionTracking";

export function usePageTracking() {
  const [location] = useLocation();
  const trackMutation = trpc.leads.trackPageview.useMutation();
  const lastTracked = useRef<string>("");

  useEffect(() => {
    if (location === lastTracked.current) return;
    lastTracked.current = location;

    const referrer = document.referrer
      ? new URL(document.referrer).hostname
      : undefined;

    trackMutation.mutate({
      path: location,
      referrer,
      sessionId: getSessionId(),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
}
